/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
  Modal,
  DatePicker,
  TreeSelect,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import {
  getEstadosGlobales,
  getFuentesDeFinanciamiento,
} from 'api/catalogos';
import Table from 'components/Table';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceived } from 'utils/formatValues';
import moment from 'moment/moment';
import { getClasificadoresObjetoGasto } from 'api/configuraciones/clasificadorObjetoGasto';
import { getClasificacionesTipoGasto } from 'api/catalogos/ClasificacionTipoGasto';
import { getProyectoPresupuestales } from 'api/catalogos/ProyectoPresupuestal';
import {
  autorizarRegistroPresupuestalIPEJAL,
  deleteRegistroPresupuestalIPEJAL,
  getRegistroPresupuestalIPEJAL,
  getRegistrosPresupuestalesIPEJAL,
  patchRegistroPresupuestalIPEJAL,
  postRegistroPresupuestalIPEJAL,
} from 'api/nominas/registroPresupuestalIPEJAL';
import { getFuncionesPresupuestales } from 'api/catalogos/funcionesPresupuestales';
import { getCatalogosDeCuentasContablesPasivo } from 'api/catalogos/CatalogoDeCuentasContablesPasivo';
import { getCOGInternos } from 'api/catalogos/clasificadoresObjetosGasto';
import { getCFFInterna } from 'api/catalogos/ClasificacionDeFuentesDeFinaciamientoInterna';
import { getProgramasPresupuestales } from 'api/catalogos/ProgramaPresupuestal';
/** cambiarlo en qa */
export const registroPresupuestalIPEJALPermission = {
  permissionModel: 'cargadereporte',
  catalogsModels: [],
  tabsModels: [],
};

const RegistroPresupuestalIPEJAL = ({ permission, idFather }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [clasificadorObjGastos, setClasificadorObjGastos] = useState([]);
  const [fuentesDeFinanciamiento, setFuentesDeFinanciamiento] = useState([]);
  const [tiposGastos, setTiposGastos] = useState([]);
  const [programasPresupuestales, setProgramasPresupuestales] = useState([]);
  const [proyectosPresupuestales, setProyectosPresupuestales] = useState([]);
  const [destinosPresupuestales, setdestinosPresupuestales] = useState([]);
  const formInstances = [
    form,
  ];

  const mapToTreeData = (nodes) => nodes.map((node) => {
    const isLeaf = !node.children || node.children.length === 0;

    return {
      title: `${node.clave} - ${node.nombre}`,
      value: node.id,
      key: node.id,
      disabled: !isLeaf, //  Deshabilita si no es hoja
      children: node.children ? mapToTreeData(node.children) : undefined,
    };
  });
  const normalizeDataCff = (_areasFetchArray) => {
    const mainMap = new Map();
    _areasFetchArray.forEach((item) => {
      mainMap.set(item.id, { ...item, children: [] });
    });

    const result = [];

    _areasFetchArray.forEach((item) => {
      if (item.clave_padre) {
        const parent = mainMap.get(item.clave_padre);
        if (parent) {
          parent.children.push(mainMap.get(item.id));
        }
      } else {
        result.push(mainMap.get(item.id));
      }
    });

    const sortByClave = (nodes) => {
      nodes.sort((a, b) => a.clave.localeCompare(b.clave));
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          sortByClave(node.children);
        }
      });
    };

    sortByClave(result);

    return result;
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getRegistrosPresupuestalesIPEJAL({ tasas_ipejal: idFather });
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _clasificadorObjGastos,
        _fuentesFinancimiento,
        _tiposGastos,
        _programasPresupuestales,
        _proyectosPresupuestales,
        _destinosPresupuestales,
        _data,
      ] = await Promise.all([
        getCOGInternos(),
        getCFFInterna(),
        getClasificacionesTipoGasto(),
        getProgramasPresupuestales(), /** programa presupuestal no encontrado */
        getProyectoPresupuestales(),
        getFuncionesPresupuestales({ estados_globales: ESTATUS_AUTORIZADO }), // asi se llama destinos presupuestales
        getRegistrosPresupuestalesIPEJAL({ tasas_ipejal: idFather }),
      ]);
      if (mounted) {
        setClasificadorObjGastos(_clasificadorObjGastos);
        setFuentesDeFinanciamiento(_fuentesFinancimiento);
        setTiposGastos(_tiposGastos);
        setProgramasPresupuestales(_programasPresupuestales);
        setProyectosPresupuestales(_proyectosPresupuestales);
        setdestinosPresupuestales(_destinosPresupuestales);
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.find((item) => item.id === key);
    const _percepcionesConfigIPEJAL = await getRegistroPresupuestalIPEJAL(match.id);

    setTimeout(() => {
      if (_percepcionesConfigIPEJAL) {
        const formValues = {
          ...formatReceived(_percepcionesConfigIPEJAL),
          cog: _percepcionesConfigIPEJAL.cog.id,
          fuente_financiamiento: _percepcionesConfigIPEJAL.fuente_financiamiento.id,
          tipo_de_gasto: _percepcionesConfigIPEJAL.tipo_de_gasto.id,
          programa_presupuestal: _percepcionesConfigIPEJAL.programa_presupuestal.id,
          proyecto_presupuestal: _percepcionesConfigIPEJAL.proyecto_presupuestal.id,
          funcion_presupuestal: _percepcionesConfigIPEJAL.funcion_presupuestal.id,
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      const _tasa_ipejal = idFather[0];
      values.tasa_ipejal = _tasa_ipejal;
      const saved = await (key ? patchRegistroPresupuestalIPEJAL(key, values) : postRegistroPresupuestalIPEJAL(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteRegistroPresupuestalIPEJAL(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Incidencia Validacion ya autorizado');
        return;
      }
      const saved = await autorizarRegistroPresupuestalIPEJAL(key);
      if (saved) {
        const _data = await getRegistrosPresupuestalesIPEJAL();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Clasificador por Objeto del Gasto',
      dataIndex: 'cog',
      key: 'cog',
      width: 200,
      render: (_, record) => record?.cog?.concepto || ' ',
    },
    {
      titleText: 'Fuente de Financiamiento',
      dataIndex: 'fuente_financiamiento',
      key: 'fuente_financiamiento',
      width: 200,
      render: (_, record) => record?.fuente_financiamiento?.nombre || ' ',
    },
    {
      titleText: 'Tipo de Gasto',
      dataIndex: 'tipo_de_gasto',
      key: 'tipo_de_gasto',
      width: 200,
      render: (_, record) => record?.tipo_de_gasto?.nombre || ' ',
    },
    {
      titleText: 'Programa Presupuestal',
      dataIndex: 'programa_presupuestal',
      key: 'programa_presupuestal',
      width: 200,
      render: (_, record) => record?.programa_presupuestal?.descripcion || ' ',
    },
    {
      titleText: 'Proyecto Presupuestal',
      dataIndex: 'proyecto_presupuestal',
      key: 'proyecto_presupuestal',
      width: 200,
      render: (_, record) => record?.proyecto_presupuestal?.descripcion || ' ',
    },
    {
      titleText: 'Destino Presupuestal',
      dataIndex: 'funcion_presupuestal',
      key: 'funcion_presupuestal',
      width: 150,
      render: (_, record) => record?.funcion_presupuestal?.nombre || ' ',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Percepciones de Configuración de IPEJAL`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="Validacion"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="cog"
                  label="Clasificador por Objeto del Gasto"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    labelProp="concepto"
                    keyProp="id"
                    render={(item) => (item ? `${item.clave} - ${item.concepto}` : '')}
                    dataSource={clasificadorObjGastos}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="fuente_financiamiento"
                  label="Fuente de Financiamiento"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    render={(item) => (item ? `${item.clave} - ${item.nombre}` : '')}
                    dataSource={fuentesDeFinanciamiento}
                  />

                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="tipo_de_gasto"
                  label="Tipo de Gasto"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    render={(item) => (item ? `${item.clave} - ${item.nombre}` : '')}
                    dataSource={tiposGastos}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="programa_presupuestal"
                  label="Programa Presupuestal"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    render={(item) => (item ? `${item.clave} - ${item.descripcion}` : '')}
                    dataSource={programasPresupuestales}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="proyecto_presupuestal"
                  label="Proyecto Presupuestal"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    render={(item) => (item ? `${item.clave} - ${item.descripcion}` : '')}
                    dataSource={proyectosPresupuestales}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="funcion_presupuestal"
                  label="Destino Presupuestal"
                  hasFeedback
                  rules={rules.required}
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    render={(item) => (item ? `${item.numero} - ${item.nombre}` : '')}
                    dataSource={destinosPresupuestales}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Percepciones de Configuraciones de IPEJAL ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Percepciones de Configuraciones de IPEJAL ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Percepciones de Configuraciones de IPEJAL ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default RegistroPresupuestalIPEJAL;
